import { CustomerType } from "@origin-digital/platform-enums";
import {
  CommonParameters,
  IMcAppType,
  NavFlow,
  Tab,
  BasicJSONSchema,
} from "../mcApp.types";

const trackingIdParameter: BasicJSONSchema = {
  description: "tracking id for an existing LPG order",
  type: "string",
};

export const lpgOrder_SAP: IMcAppType = {
  name: "lpgOrder_SAP",
  path: "/my-account/order-lpg/:customerNumber/order",
  parameters: {
    required: ["customerNumber"],
    properties: { customerNumber: CommonParameters.customerNumber },
  },
  description: "Place an LPG order",
  navFlow: NavFlow.FOCUS,
  parent: Tab.MORE,
  title: "LPG Order",
  conditions: {
    intent: "lpgOrder",
    customerType: CustomerType.sap,
  },
};

export const lpgOrder_KRAKEN: IMcAppType = {
  name: "lpgOrder_KRAKEN",
  path: "/my/service/lpg/:customerNumber/order",
  parameters: {
    required: ["customerNumber"],
    properties: { customerNumber: CommonParameters.customerNumber },
  },
  description: "Place an LPG order",
  navFlow: NavFlow.FOCUS,
  parent: Tab.MORE,
  title: "LPG Order",
  conditions: {
    intent: "lpgOrder",
    customerType: CustomerType.kraken,
  },
};

export const lpgOrderTrack_SAP: IMcAppType = {
  name: "lpgOrderTrack_SAP",
  path: "/my-account/order-lpg/track/:trackingId",
  parameters: {
    required: ["trackingId"],
    properties: {
      trackingId: trackingIdParameter,
    },
  },
  description: "Track an LPG order",
  navFlow: NavFlow.FOCUS,
  parent: Tab.MORE,
  title: "Track LPG Order",
  conditions: {
    intent: "lpgOrderTrack",
    customerType: CustomerType.sap,
  },
};

export const lpgOrderTrack_KRAKEN: IMcAppType = {
  name: "lpgOrderTrack_KRAKEN",
  path: "/my/service/lpg/track/:trackingId",
  parameters: {
    required: ["trackingId"],
    properties: {
      trackingId: trackingIdParameter,
    },
  },
  description: "Track an LPG order",
  navFlow: NavFlow.FOCUS,
  parent: Tab.MORE,
  title: "Track LPG Order",
  conditions: {
    intent: "lpgOrderTrack",
    customerType: CustomerType.kraken,
  },
};
